// extracted by mini-css-extract-plugin
module.exports = {"Cover":"full_Cover__1lxM7","fadeIn":"full_fadeIn__2uIzU","Text":"full_Text__3Orv0","Loader":"full_Loader__2SwKb","Loaderg":"full_Loaderg__1Qcz6","Loaderd":"full_Loaderd__1QMdu"};